module.exports = __webpack_public_path__ + "static/media/circle-number.ecd4698e.png";